import type { FC } from "react";
import { useLocation } from "react-router-dom";

import { AutoDeletePolicyNudge } from "@/components/nudges/AutoDeletePolicyNudge";
import { AutomationsLaunchNudge } from "@/components/nudges/AutomationsLaunchNudge";
import { DownloadAppNudge } from "@/components/nudges/DownloadAppNudge";
import { PrivacyPolicyNudge } from "@/components/nudges/PrivacyPolicyNudge";
import { cn } from "@/components/podkit/lib/cn";
import { useNudges } from "@/hooks/use-nudges";

// Note: AutoDeletePolicyNudge is intentionally NOT included in this stack.
// It is always shown at the bottom of the archive sidebar (see ArchivedSidebar.tsx) and is always lowest priority.
// This is per product requirements: it only appears when the org auto-delete policy changes.
//
// Note: VERSION_UPDATE is handled by UpdateChip/UpdateDot in the sidebar header
// (see SidebarLogoToggle.tsx), not as a bottom-left modal nudge.

export const Nudges: FC = () => {
    const { isPending, active } = useNudges();
    const location = useLocation();
    const isSettingsPage = location.pathname.startsWith("/settings");

    // Hide nudges when on settings pages
    const shouldHideNudges = !active || isSettingsPage;

    if (isPending) {
        return null;
    }

    return (
        <div data-testid="nudges" className={cn("flex gap-4", { hidden: shouldHideNudges })}>
            <PrivacyPolicyNudge />

            <AutoDeletePolicyNudge />
            <AutomationsLaunchNudge />
            <DownloadAppNudge />
        </div>
    );
};
